import Sidebar from '../../../components/sidebar/Sidebar'
import Header from '../../../components/headerbar/Header'
// import "./product.scss";
import { useParams, useNavigate } from 'react-router-dom'
import {config} from '../../../config'
import { useState, useEffect } from 'react'
import axios from 'axios'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { useFormik } from 'formik'
import * as yup from 'yup'



const TestimonialsEdit = () => {
  const accesstoken = JSON.parse(localStorage.getItem('user'))
  const [testimonialsList, setTestimonialsList] = useState([])
  const navigate = useNavigate()
  useEffect(() => {
    getBanner()
    getProductedit()
  }, [])

  const [imagepreview, setImagepreview] = useState('')
  const [imagede, setImagede] = useState('')

  const [updateid, setUpdateid] = useState('')
  const [error, setError] = useState(false)
  const params = useParams()

  const getBanner = async () => {
    let bannerresult = await fetch(config.apiurl + '/testlist/get_test')
    bannerresult = await bannerresult.json().catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"}))
    setTestimonialsList(bannerresult.data.results)
  }

  const getProductedit = async () => {
    let proeditdetails = await fetch(
      config.apiurl + '/testlist/' + params.editid,
      {
        method: 'get',
        headers: {
          Authorization: 'bearer ' + accesstoken.data.access_token,
        },
      }
    )
    proeditdetails = await proeditdetails.json().catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"}))
    formik?.setFieldValue('name', proeditdetails?.data?.[0]?.name)
    formik?.setFieldValue('content', proeditdetails?.data?.[0]?.content)
    formik?.setFieldValue('image', proeditdetails?.data?.[0]?.image)

    if (params) {
      setImagepreview(config.fileurl + proeditdetails?.data?.[0]?.image)
    }
  }

  const handleImageupload = async (event) => {
    const fileup = event.target.files[0]
    Transformfile(fileup)
  }

  const Transformfile = (file) => {
    if (file) {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onloadend = () => {
        setImagepreview(reader.result)
        setImagede(file)
        formik?.setFieldValue('image', file.name)
      }
    }
  }

  const submitProductDetails = async (data, res) => {
    const editupdateurl = config.apiurl + '/testlist/' + params.editid
    const configdata = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'bearer ' + accesstoken.data.access_token,
      },
    }

    const ondataSuccess = (response) => {
      toast('Updated successfully')
      setTimeout(() => {
        navigate('/testimonial')
      }, 2000)
    }
    const ondataFailure = (err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", { type: "error", })
    const editdata = {
      name: data.name,
      content: data.content,
      image: res,
    }
    axios
      .put(editupdateurl, editdata, configdata)
      .then(ondataSuccess, ondataFailure)
  }

  const handleProsubmit = async (formValues) => {
    const data = {
      name: formValues?.name,
      content: formValues?.content,
      image: formValues?.image,
    }
    if (!data.image) {
      setError(true)
      return false
    }
    /*Image Upload process here */
    if (imagede) {
      const imageupurl = config.apiurl + '/upload/upload-single'
      const configimg = {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: 'bearer ' + accesstoken.data.access_token,
        },
      }
      const formData = new FormData()
      formData.append('file', imagede)

      const onSuccess = (response) => {
        submitProductDetails(data, response.data.data.filename)
      }
      const onFailure = (err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", { type: "error", })
      axios.post(imageupurl, formData, configimg).then(onSuccess, onFailure)
    } else {
      submitProductDetails(data, data.image)
    }
  }

  const formik = useFormik({
    initialValues: {
      name: '',
      image: '',
      content: '',
    },
    enableReinitialize: true,
    validationSchema: yup.object({
      name: yup
        .string()
        .required('Enter the name')
        .trim()
        .min(3, `Must be min 3 characters are required`)
        .max(50, `Max 50 characters are allowed`)
        .nullable(),
      image: yup.string().required('Choose the image').nullable(),
      content: yup
        .string()
        .required('Enter the content')
        .trim()
        .max(500, 'Max 500 characters are allowed')
        .nullable(),
    }),
    onSubmit: handleProsubmit,
  })

  return (
    <>
      <div className="min-height-300 bg-primary position-absolute w-100"></div>
      <Sidebar />
      <main className="main-content position-relative border-radius-lg ">
        <Header />
        <div className="container-fluid py-4">
          <div className="row">
            <div className="col-12">
              <div className="card mb-4">
                <div className="card-header pb-3">
                  <div className="row">
                    <div className="col-6 d-flex align-items-center">
                      <h6 className="mb-0">Edit Testimonial</h6>
                    </div>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Name
                        </label>

                        <input
                          name="name"
                          className="form-control"
                          type="text"
                          value={formik?.values?.name}
                          onChange={formik?.handleChange}
                        />
                        {formik?.errors?.name &&
                          formik?.touched?.name &&
                          formik?.errors?.name && (
                            <span className="text-danger text-gradient text-xs text-secondary">
                              {formik?.errors?.name}
                            </span>
                          )}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Image
                        </label>
                        <input
                          className="form-control"
                          type="file" accept="image/png, image/jpeg"
                          onChange={(event) => handleImageupload(event)}
                        />
                        {formik?.errors?.image &&
                        formik?.touched?.image &&
                        formik?.errors?.image && (
                          <span className="text-danger text-gradient text-xs text-secondary">
                            {formik?.errors?.image}
                          </span>
                        )}
                      </div>
                    </div>
                    {imagepreview ? (
                      <div className="col-md-6">
                        {<img src={imagepreview} width="150" height="150" />}
                      </div>
                    ) : null}
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Content
                        </label>
                       
                        <textarea
                          name="content"
                          className="form-control"
                          rows="5"
                          value={formik?.values?.content}
                          onChange={formik?.handleChange}
                        />
                        {formik?.errors?.content &&
                          formik?.touched?.content &&
                          formik?.errors?.content && (
                            <span className="text-danger text-gradient text-xs text-secondary">
                              {formik?.errors?.content}
                            </span>
                          )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="text-end">
                      <button
                        type="button"
                        onClick={formik?.handleSubmit}
                        className="btn btn-primary btn-sm ms-auto mt-5"
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <ToastContainer />
    </>
  )
}

export default TestimonialsEdit
